import { NextPage, GetServerSideProps, InferGetServerSidePropsType } from 'next';

import { WithLegacy } from '~/_legacy/components/WithLegacy';

import { apiGetV1PresentationById } from '~/api/v1/presentations/[id]/get';
import { OnlyWeb } from '~/components/_for-next/OnlyWeb';
import { WithNextSeo } from '~/components/_for-next/WithNextSeo';

import Presentation from './_template/_Presentation';

export const getServerSideProps = (async ({ query }) => {
  const id = String(query.id);
  // NOTE: 検索エンジンがidを数字ではない文字列でアクセスすることが多いので、その場合はnotFound
  if (!/^\d+$/.test(id)) return { notFound: true };
  const presentation = await apiGetV1PresentationById({ id });
  return { props: { id, presentation } };
}) satisfies GetServerSideProps;

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

const Page: NextPage<Props> = ({ presentation }) => {
  return (
    <WithNextSeo
      title={presentation?.title || 'プレゼンテーション'}
      description={presentation?.description}
      image={presentation?.thumbnail}
      url={`https://susnet.jp/presentations/${presentation?.id}`}
    >
      <OnlyWeb>
        <WithLegacy>
          <Presentation presentationJson={presentation} />
        </WithLegacy>
      </OnlyWeb>
    </WithNextSeo>
  );
};

export default Page;
